var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "tr",
    {
      staticClass: "row",
      class: {
        selected: _vm.isSelected,
        bold: _vm.isBold,
        hidden: _vm.isHidden,
      },
      on: {
        click: function ($event) {
          return _vm.onRowClick()
        },
      },
    },
    [
      _c(
        "td",
        { staticStyle: { width: "20px" } },
        [_c("w-fa", { staticClass: "handle", attrs: { icon: "ellipsis-v" } })],
        1
      ),
      _c("td", { staticStyle: { width: "80px" } }, [
        _vm.row.Duration
          ? _c("span", [
              _vm._v(" " + _vm._s(_vm.humanDuration(_vm.row.Duration)) + " "),
            ])
          : _c("span", [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.humanFloat(_vm.row.Amount, _vm.decimalSettings.Qty)
                  ) +
                  " "
              ),
            ]),
      ]),
      _c("td", { staticStyle: { width: "80px" } }, [
        _vm._v(" " + _vm._s(_vm.row.UnitName) + " "),
      ]),
      _c(
        "td",
        {
          staticClass: "description",
          class: { noSku: !_vm.row.ProductSku },
          staticStyle: { overflow: "hidden" },
        },
        [
          _c("span", {
            directives: [
              {
                name: "safe-html",
                rawName: "v-safe-html",
                value: _vm.displayedProductDescription,
                expression: "displayedProductDescription",
              },
            ],
            staticClass: "inner-description",
          }),
          _vm.row.ProductSku
            ? _c("small", [_vm._v(_vm._s(_vm.row.ProductSku))])
            : _vm._e(),
        ]
      ),
      _c("td", { staticClass: "align-r", staticStyle: { width: "125px" } }, [
        _vm._v(
          " " +
            _vm._s(
              _vm.humanFloat(_vm.row.UnitPrice, _vm.decimalSettings.Unit)
            ) +
            " "
        ),
      ]),
      _c("td", { staticClass: "align-r", staticStyle: { width: "100px" } }, [
        _vm._v(" " + _vm._s(_vm.humanFloat(_vm.row.Discount, 2)) + " "),
      ]),
      _c("td", { staticClass: "align-r", staticStyle: { width: "60px" } }, [
        _vm._v(" " + _vm._s(_vm.humanFloat(_vm.row.Vat, 1)) + " "),
      ]),
      _c("td", { staticClass: "align-r", staticStyle: { width: "100px" } }, [
        _vm._v(
          " " +
            _vm._s(_vm.humanFloat(_vm.netto, _vm.decimalSettings.Unit)) +
            " "
        ),
      ]),
      _c("td", { staticClass: "align-r", staticStyle: { width: "100px" } }, [
        _vm._v(
          " " +
            _vm._s(_vm.humanFloat(_vm.bruto, _vm.decimalSettings.Unit)) +
            " "
        ),
      ]),
      _c(
        "td",
        { staticStyle: { width: "32px" } },
        [
          _c(
            "w-dropdown",
            {
              staticClass: "dropdown",
              attrs: {
                items: _vm.options,
                flat: "",
                center: "",
                right: "",
                "auto-up": "",
              },
              on: {
                click: function ($event) {
                  return _vm.trigger($event)
                },
                remove: function ($event) {
                  return _vm.onRemove()
                },
              },
              nativeOn: {
                click: function ($event) {
                  return _vm.forceSelect(_vm.row)
                },
              },
            },
            [_c("w-fa", { attrs: { icon: "bars", size: "xs" } })],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }